import { CircularProgress, Grid, Typography } from "@mui/material";
import ToggleButton, { toggleButtonClasses } from "@mui/material/ToggleButton";
import ToggleButtonGroup, { toggleButtonGroupClasses } from "@mui/material/ToggleButtonGroup";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import styles from "./main.module.css";
import paeezLogo from "../../assets/images/paeez-logo.png";
import Card from "../../components/ItemCard/Card";
import { getCategories } from "../../utils/api/categories/getCategories";
import { useQuery } from "react-query";
import { getItems } from "../../utils/api/items/getItems";
import { CallOutlined, Instagram } from "@mui/icons-material";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  gap: "1rem",
  [`& .${toggleButtonGroupClasses.firstButton}`]: {
    marginRight: "1rem",
  },
  [`& .${toggleButtonGroupClasses.lastButton}`]: {
    marginLeft: "1rem",
  },
  [`& .${toggleButtonClasses.selected}`]: {
    border: "1px solid #f2b600",
    backgroundColor: "unset !important",
    borderRadius: 50,
  },
  [`& .${toggleButtonGroupClasses.firstButton}, & .${toggleButtonGroupClasses.middleButton}`]: {
    borderRadius: 50,
  },
  [`& .${toggleButtonGroupClasses.lastButton}, & .${toggleButtonGroupClasses.middleButton}`]: {
    borderRadius: 50,
    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`,
  },
  [`& .${toggleButtonGroupClasses.lastButton}.${toggleButtonClasses.disabled}, & .${toggleButtonGroupClasses.middleButton}.${toggleButtonClasses.disabled}`]:
    {
      borderLeft: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`,
    },
  [`& .${toggleButtonGroupClasses.lastButton}.${toggleButtonClasses.selected}, & .${toggleButtonGroupClasses.middleButton}.${toggleButtonClasses.selected}`]:
    {
      borderLeft: `1px solid #f2b600`,
    },
}));

const Main = () => {
  const [alignment, setAlignment] = useState(null);

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment) {
      setAlignment(newAlignment);
      setTimeout(() => getItemsQuery.refetch(), 200);
      setTimeout(() => event?.target?.scrollIntoView({ behavior: "smooth", inline: "center", block: "center" }), [200]);
    }
  };

  const getCategoriesQuery = useQuery(["get-categories-query"], (data) => getCategories(data), {
    onSuccess: (data) => {
      handleAlignment(null, data.data.categories[0].id);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const getItemsQuery = useQuery(["get-items-query", alignment], () => getItems({ id: alignment }), {
    enabled: false,
    onSuccess: (data) => {},
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className={styles["main-container"]}>
      <Grid container direction={"column"} className={styles["grid-wrapper"]}>
        <Grid item size={12}>
          <Grid container direction={"row"}>
            <Grid item size={4}>
              <Grid
                container
                alignItems={"flex-start"}
                direction='column'
                justifyContent={"center"}
                style={{ paddingRight: 30, height: "100%" }}
              >
                <CallOutlined
                  style={{ height: 38, width: 38 }}
                  color='disabled'
                  onClick={() => window.open("tel:+989139309961", "_blank")}
                />
              </Grid>
            </Grid>
            <Grid item size={4}>
              <div className={styles["header-container"]}>
                <img src={paeezLogo} className={styles["paeez-logo"]} />
              </div>
            </Grid>
            <Grid item size={4}>
              <Grid
                container
                alignItems={"flex-end"}
                direction='column'
                justifyContent={"center"}
                style={{ paddingLeft: 30, height: "100%" }}
              >
                <Instagram
                  style={{ height: 40, width: 40 }}
                  color='disabled'
                  onClick={() => window.open("https://www.instagram.com/paeezcafe95/", "_blank")}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item size={12} className={styles["toggle-button-container"]}>
          {getCategoriesQuery.isLoading ? (
            <Grid container alignItems={"center"} justifyContent={"center"} style={{ height: "100%" }}>
              <CircularProgress />
            </Grid>
          ) : (
            <StyledToggleButtonGroup
              value={alignment}
              exclusive
              onChange={handleAlignment}
              aria-label='text alignment'
              orientation='horizontal'
              className={styles["toggle-button-group"]}
            >
              {getCategoriesQuery.data?.data?.categories.map((item, index) => (
                <ToggleButton
                  value={item.id}
                  size='large'
                  aria-label='left aligned'
                  className={styles["toggle-button"]}
                >
                  <div className={styles["toggle-reserve"]} style={{ width: alignment === item.id ? 180 : 100 }}></div>
                  <div className={styles["gradient"]}></div>
                  <div className={styles["image-container"]}>
                    <img
                      alt='coffe itemx'
                      src={process.env.REACT_APP_PHOTOS_ENDPOINT + "/" + item.photo_url}
                      className={styles["item-image"]}
                    />
                  </div>
                  <div className={styles["text-container"]}>
                    <div className={styles["text-container-child"]}>{item.title}</div>
                  </div>
                </ToggleButton>
              ))}
            </StyledToggleButtonGroup>
          )}
        </Grid>
        <Grid item size={12}>
          {getItemsQuery.isLoading ? (
            <Grid container alignItems={"center"} justifyContent={"center"} style={{ height: "100%" }}>
              <CircularProgress />
            </Grid>
          ) : (
            <Grid container direction={"row"} alignItems={"center"} justifyContent={"flex-start"}>
              {getItemsQuery?.data?.data?.items.map((item) => (
                <Grid
                  item
                  size={{ xs: 6, sm: 3, md: 3, lg: 2 }}
                  style={{ paddingLeft: 5, paddingBottom: 10, paddingRight: 10 }}
                >
                  <Card
                    imgSrc={process.env.REACT_APP_PHOTOS_ENDPOINT + "/" + item.photo_url}
                    title={item.title}
                    description={item.description}
                    price={item.price}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
        <Grid item size={12} style={{ padding: 20 }}>
          <Grid container direction='column' alignItems={"center"} justifyContent={"center"}>
            <img src={paeezLogo} style={{ marginBottom: 10, height: 100 }} />
            <Typography style={{ fontSize: 17, color: "#f2b600" }}>۱۳۹۵</Typography>
            <Typography style={{ fontSize: 17, color: "#fff", marginTop: 5 }}>۱۳۹۶</Typography>
            <Typography style={{ fontSize: 17, color: "#fff", marginTop: 5 }}>۱۳۹۷</Typography>
            <Typography style={{ fontSize: 17, color: "#fff", marginTop: 5 }}>۱۳۹۸</Typography>
            <Typography style={{ fontSize: 17, color: "#fff", marginTop: 5 }}>۱۳۹۹</Typography>
            <Typography style={{ fontSize: 17, color: "#fff", marginTop: 5 }}>۱۴۰۰</Typography>
            <Typography style={{ fontSize: 17, color: "#fff", marginTop: 5 }}>۱۴۰۱</Typography>
            <Typography style={{ fontSize: 17, color: "#fff", marginTop: 5 }}>۱۴۰۲</Typography>
            <Typography style={{ fontSize: 17, color: "#fff", marginTop: 5 }}>۱۴۰۳</Typography>
            <Typography style={{ fontSize: 17, color: "#fff", marginTop: 5 }}>۱۴۰۴</Typography>
            <Typography style={{ fontSize: 17, color: "#f2b600", marginTop: 5, marginBottom: 70 }}>۱۴۰۵</Typography>
          </Grid>
        </Grid>

        <Grid
          item
          size={12}
          style={{
            padding: 10,
            position: "fixed",
            bottom: -5,
            left: 0,
            right: 0,
            zIndex: 8,
            height: 80,
            background: "linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(255, 255, 255, 0) 100%)",
            mask: "linear-gradient(0deg, black, black, transparent)",
            backdropFilter: "blur(5px)",
          }}
        >
          <Grid container direction='column' alignItems={"center"} justifyContent={"center"}>
            {/* <Typography style={{ textAlign: "center", fontSize: 14, color: "#fff", marginTop: 5 }}>
              به تمام آیتم های منو ۱۰٪ مالیات برارزش افزوده اضافه میگردد.
            </Typography> */}
            <Typography style={{ textAlign: "center", fontSize: 20, color: "#fff", marginTop: 10 }}>
              لطفاً روبروی صندوق سفارش دهید
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Main;
